//import Ractive from 'ractive'
import template from '../../templates/template.html'

export class App {

	constructor(data) {

		var self = this

		self.database = data

		for (var i = 0; i < self.database.profile.length; i++) {

			self.database.profile[i].h4 = (self.database.profile[i].type=="headline") ? true : false ;
			
		}

		self.ractivate()
		
	}

    ractivate() {

        var self = this

        this.ractive = new Ractive({
            el: '#app',
            data: self.database,
            template: template,
        })

    }
}